import React from 'react';
import styles from '../../utils/styles/components/Loading/style.module.css';

export const Loading = ({ label = 'Chargement en cours...' }) => {
  return <p className={styles.loading}>{label}</p>;
};
